<template>
    <b-row style="margin-top: 20px; margin-bottom: 20px">
        <b-col>
            <div class="result_search_favoris" v-if="searched_participants.length > 0">
                <div class="result_favoris_item" v-for="(participant, index) in searched_participants" :key="index">
                    <div class="favoris_nation_col">
                        <img class="flag_favoris"
                            :src="'https://sportips.fr/live/img/Flags/' + participant.nation + '.jpg'" />
                    </div>
                    <div class="favoris_info_col">
                        <p>
                            <b>{{ participant.dossard }} {{ participant.nom }} {{ participant.prenom }}</b>
                        </p>
                        <p>{{ participant.course }}</p>
                    </div>
                    <div class="favoris_add_col">
                        <router-link
                            :to="{ path: '/' + $store.state.module.base + '/fiche/' + participant.id }"><b-button>Ouvrir</b-button></router-link>
                    </div>
                </div>
            </div>
        </b-col>
    </b-row>
</template>

<script>
export default {
    computed: {
        searched_participants() {
            return this.$store.getters["listCoureurs/searched_participants"];
        }
    }

}
</script>

<style lang="scss" scoped></style>